import React from "react";
import "./service.css";
import FAQSection from "../components/faq.js"; 
import { Link } from "react-router-dom";

const services = [
  {
    icon: "/icons/web-dev.svg",
    title: "Web Development",
    description: "Scalable, modular websites built with React and modern frameworks."
  },
  {
    icon: "/icons/infrastructure.svg",
    title: "Infrastructure Management Service",
    description: "Reliable IT infrastructure monitoring, optimization, and support."
  },
  {
    icon: "/icons/cybersecurity.svg",
    title: "Cybersecurity",
    description: "Protect your business with advanced security solutions and monitoring."
  },
  {
    icon: "/icons/cloud.svg",
    title: "Cloud Service",
    description: "Flexible cloud solutions for storage, computing, and collaboration."
  },
  {
    icon: "/icons/domain.svg",
    title: "Domain Registration",
    description: "Secure and manage your domain names with ease."
  },
  {
    icon: "/icons/hosting.svg",
    title: "Hosting",
    description: "Fast, reliable hosting services tailored to your business needs."
  },
  {
    icon: "/icons/cctv.svg",
    title: "CCTV Installation",
    description: "Secure your premises with professional CCTV setup and monitoring solutions."
  },
  { icon: "/icons/biometrics.png", 
    title: "Biometrics", 
    description: "Advanced biometric authentication solutions for secure access and identity management." 
  }
];

const steps = [ { number: "1", title: "Consultation", description: "We listen to your goals." }, { number: "2", title: "Strategy", description: "We design a tailored plan." }, { number: "3", title: "Execution", description: "We deliver with precision." }, { number: "4", title: "Support", description: "We optimize continuously." } ];

export default function ServicesPage() {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="service-hero">
        <h1>Our Services</h1>
        <p>Solutions designed to build trust and drive growth.</p>
        <Link to="/contact"><button className="service-cta-btn">Get Started</button></Link>  
      </section>

      {/* Services Grid */}
      <section className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <img
              src={service.icon}
              alt={service.title + " icon"}
              className="service-icon"
            />
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </section>

      {/* Process Timeline */}
<section className="process-timeline">
      <h2>How We Work</h2>
      <div className="timeline">
        {steps.map((step, index) => (
          <div key={index} className="step">
            <span>{step.number}</span>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </div>
        ))}
      </div>
    </section>

{/* FAQ Accordion */}
<FAQSection />

      {/* Feature Highlight */}
      <section className="feature-highlight">
  <div className="feature-text">
    <h2>✨ Innovation at the Core</h2>
    <p>
      We combine creativity and technology to deliver solutions that
      stand out. Every project is tailored to your brand identity.
    </p>
    <Link to="/contact"><button className="feature-btn">Discover More</button></Link>
  </div>
  <div className="feature-image">
    <div className="image-wrapper">
      <img src="/images/inno.png" alt="Innovation" />
    </div>
  </div>
</section>

      {/* CTA Banner */}
      <section className="service-cta-banner">
        <h2>Ready to Transform Your Business?</h2>
        <Link to="/contact"><button className="service-cta-btn">Contact Us</button></Link>
      </section>
    </div>
  );
}